@if (clientForm) {
    <form [formGroup]="clientForm">
        @if (showSearchField) {
            <div class="search-field-wrapper" #searchFieldWrapper>
                <app-input
                    icon="search-icon"
                    [placeholder]="'SearchContactByPhoneOrEmail' | localize"
                    formControlName="phoneNumberOrEmail"
                    sanitizeContactSearch
                    (valueChange)="clearMatchedClient()"
                />
            </div>
        }

        <div class="form-sections-wrapper">
            @if (showAddClientForm) {
                <app-form-section>
                    <app-input
                        [disabled]="disableCreateForm"
                        [label]="'FirstName' | localize"
                        [placeholder]="'FirstName' | localize"
                        formControlName="firstName"
                        noSpaces
                    />

                    <app-input
                        [disabled]="disableCreateForm"
                        [label]="'LastName' | localize"
                        [placeholder]="'LastName' | localize"
                        formControlName="lastName"
                        noSpaces
                    />

                    @for (contactDetail of contactDetailsControls; track contactDetail) {
                        <ng-container [formGroup]="contactDetail">
                            @if (contactDetail.value.contactDetailId === ContactDetailId.Phone) {
                                <app-tel-input
                                    [disabled]="disableCreateForm"
                                    [label]="'Phone' | localize"
                                    formControlName="value"
                                    (dialCodeChange)="onPhoneDialCodeChange()"
                                />
                            } @else {
                                <app-input
                                    [disabled]="disableCreateForm"
                                    [label]="ContactDetailId[contactDetail.value?.contactDetailId]?.toString() | localize"
                                    [placeholder]="ContactDetailId[contactDetail.value?.contactDetailId]?.toString() | localize"
                                    formControlName="value"
                                />
                            }
                        </ng-container>
                    }
                </app-form-section>
            }

            @if (showSources) {
                <app-form-section>
                    <app-dropdown
                        [disabled]="disableCreateForm"
                        [label]="'Source' | localize"
                        [placeholder]="'Source' | localize"
                        [options]="sourceCategory?.value | selectedAwareOptions: sourceCategoriesOptions"
                        (onSelectionChange)="onSourceCategoryChanged($event)"
                        formControlName="source"
                        [isAutocomplete]="false"
                    />

                    <app-dropdown
                        [disabled]="disableCreateForm"
                        [label]="'SubSource' | localize"
                        [placeholder]="'SubSource' | localize"
                        [options]="subSourceCategory?.value | selectedAwareOptions: subSourceCategoriesOptions"
                        [disabled]="!sourceCategoryId"
                        (onSearchChange)="filterSubSourceCategories()"
                        (onSelectionChange)="onSubSourceCategoryChanged($event)"
                        formControlName="subSource"
                        [isAutocomplete]="false"
                    />

                    @if (showSourceDetail) {
                        <app-dropdown
                            [disabled]="disableCreateForm"
                            [label]="'SourceDetail' | localize"
                            [placeholder]="sourceDetailPlaceholder"
                            [options]="sourceDetailOptions"
                            (onSearchChange)="filterSourceDetails($event)"
                            formControlName="sourceDetail"
                            [forceSelection]="true"
                        />
                    }
                </app-form-section>

                @if (showPopupSpacer) {
                    <div class="popup-spacer"></div>
                }
            }
        </div>

        @if (showClientMatch) {
            <section class="client-match">
                <span class="title">{{ 'HasContactMatch{0}' | localize: matchedClient.id }}</span>
                <section class="section">
                    <div class="summary">
                        <div class="client">
                            <a class="text bold client-link"
                                [routerLink]="[AppPathConsts.ClientsDetails, matchedClient.id]"
                                target="_blank">
                                {{ this.matchedClientName }}
                            </a>
                        </div>
                        <div class="details">
                            <span class="text bold">{{ 'Details' | localize }}:</span>
                            <span class="text">{{ this.matchedClient.email }}</span>
                            <span class="text phone">
                                <app-svg-icon icon="phone-ringing" /> {{ this.matchedClient.phoneNumber }}
                            </span>
                            @if (showMatchedClientSource && matchedClientSource) {
                                <span class="text">{{ 'Source' | localize }}: {{ this.matchedClientSource }}</span>
                            }
                        </div>
                    </div>

                    <app-client-offers-searches-projects
                        [offers]="offers"
                        [searches]="searches"
                        [projects]="projects"
                        [showSurveyActions]="showSurveyActions"
                        (surveyActionClicked)="surveyActionClicked.emit($event)"
                    />
                </section>
            </section>
        }

        @for (group of otherCompaniesActivity; track group.tenantId) {
            <section class="other-company-match">
                <div class="other-company-header">
                    <img [src]="group.tenantId | smallCompanyLogo" class="company-logo" alt="company" />
                    <span class="title">{{ 'ContactMatchInCompany{0}' | localize: group.companyName }}</span>
                </div>

                <app-client-offers-searches-projects
                    [offers]="group.offers"
                    [searches]="group.searches"
                    [projects]="group.projects"
                    [tenantId]="group.tenantId"
                    [disableOnClick]="true"
                />
            </section>
        }

        <div class="button-wrapper">
            @if (isClientSearched) {
                @if (!matchedClient) {
                    <app-button [disabled]="disableCreateForm || !clientForm.valid" (onSubmit)="createClient()">
                        {{ 'SaveAndNext' | localize }}
                    </app-button>
                } @else if (showAddToMyClientsButton) {
                    <app-button [disabled]="shouldDisableWithMatchedClientButton" (onSubmit)="addToMyClients()">
                        {{ withMatchedClientButtonText }}
                    </app-button>
                }
            } @else {
                <app-button [disabled]="!enableCheckButton" (onSubmit)="fetchClient()">
                    {{ 'CheckAndContinue' | localize }}
                </app-button>
            }
        </div>
    </form>
}
